export enum FullOrderState {
  expired = 'expired',
  invalid = 'invalid',
  open = 'open',
  taken = 'taken',
}

